import { render, staticRenderFns } from "./validation_errors.vue?vue&type=template&id=19c96a92&"
import script from "./validation_errors.vue?vue&type=script&lang=js&"
export * from "./validation_errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports